<template>
    <div>
        <h3 class="mb-3">{{ $t('access') }}</h3>
        
        <CheckboxInput 
            v-for="role in roles" 
            :key="role.id" 
            :label="role.name"
            :value="user.roles && user.roles.includes(parseInt(role.id))" 
            @input="toggleRole(role.id)"
        >
            <template v-slot:label><span class="font-weight-bold">{{ role.name }}</span></template>
            <template v-slot:footer>
                <div>{{ role.description }}</div>
            </template>
        </CheckboxInput>
    </div>
</template>

<script>
import CheckboxInput from '../Inputs/CheckboxInput.vue';

export default {
    props: {
        user: Object,
        roles: Array,
    },
    methods: {
        toggleRole(id) {
            const index = this.user.roles.findIndex((role) => role == id)
            
            if (index > -1) {
                this.user.roles.splice(index, 1)
                return
            }
            
            this.user.roles.push(parseInt(id))
        },
        
    },
    components: { CheckboxInput },
}
</script>